export const iconFontAwesomeMovingSignHanging = (
	<i className="fa-solid fa-sign-hanging"></i>
);
